import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "call_out",
  "use": "call_out-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"call_out\">\r\n<path d=\"M10,1H4C3.448,1,3,1.448,3,2s0.448,1,1,1h3.586L1.293,9.293c-0.391,0.391-0.391,1.023,0,1.414\r\n\tC1.488,10.902,1.744,11,2,11s0.512-0.098,0.707-0.293L9,4.414V8c0,0.552,0.448,1,1,1c0.553,0,1-0.448,1-1V2C11,1.448,10.553,1,10,1z\r\n\t\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol